import script from "./ResultTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultTable.vue?vue&type=script&setup=true&lang=ts"

import "./ResultTable.vue?vue&type=style&index=0&id=0974a388&lang=scss&scoped=true"

import exportComponent from "/builds/ext/ERCO/productdata-archive-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0974a388"]])

export default __exports__